import React from "react";
import {
  FaRegHeart,
  FaHeart,
  FaBalanceScale,
  FaTools,
} from "react-icons/fa";

import styles from "../../styles/pages/product/ProductDetailsPage.module.css";

const ProductActionTools = ({
  isFavorite,
  onToggleFavorite,
  onCompare,
  setupItem,
  onSetupClick,
}) => {
  const isInSetup = !!setupItem;
  return (
    <div className={styles.userTools}>
      <button
        className={styles.favoritebutton}
        onClick={onToggleFavorite}
        title="Add to favorites"
        type="button"
      >
        {isFavorite ? <FaHeart size={24} /> : <FaRegHeart size={24} />}
      </button>

      <button
        className={styles.compareButton}
        onClick={onCompare}
        title="Add to comparison"
        type="button"
      >
        <FaBalanceScale size={20} />
        <span>Compare</span>
      </button>

      <button
        className={`${styles.addToListButton} ${isInSetup ? styles.addToListButtonActive : ""}`}
        onClick={onSetupClick}
        title={isInSetup ? "Edit in My Setup" : "Add to My Setup"}
        type="button"
      >
        <FaTools size={20} />
        <span>{isInSetup ? "In My Setup" : "Add to Setup"}</span>
      </button>
    </div>
  );
};

export default ProductActionTools;
